export async function analyzeDocumentWithAI(text: string) {
  const apiKey = import.meta.env.VITE_OPENROUTER_API_KEY;
  const model = "google/gemini-2.5-flash-preview-05-20";
  const url = "https://openrouter.ai/api/v1/chat/completions";
  
  const prompt = `Analyze this document text and provide a detailed analysis in the following format:

DOCUMENT AUTHENTICITY ASSESSMENT
- Classification: [authentic/likely manipulated/AI-generated]
- Confidence Score: [0-100]%

KEY FINDINGS
- [List 2-3 main findings about the document's content and structure]

EVIDENCE
- [List 2-3 specific pieces of evidence supporting the classification]

RECOMMENDATIONS
- [List 2-3 specific recommendations for verification or further analysis]

Format the response in plain text without any markdown symbols (no #, *, etc.). Use clear section headers and bullet points with dashes (-).

Document text:
${text.slice(0, 4000)}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model,
      messages: [
        {
          role: "user",
          content: prompt
        }
      ]
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to analyze document with AI");
  }

  const data = await response.json();
  return data.choices?.[0]?.message?.content || "No analysis available";
} 